import { useTranslation } from "react-i18next";
import { useMemo, useCallback } from "react";
import { preferencesNew } from "resources/data/preferencesNew";

// ** Custom Components
import MenuList from "components/layout/Menu/List";
import Text from "components/typography/Text";
import SexIcon from "components/icons/SexIcon";
import SportIcon from "components/icons/SportIcon";
import HobbyIcon from "components/icons/HobbyIcon";
import LifeStyleIcon from "components/icons/LifeStyleIcon";
import CultureIcon from "components/icons/CultureIcon";
import FoodIcon from "components/icons/FoodIcon";
import { PreferencesSelectorChildMulti } from "../PreferencesSelectorChildMulti";

const PreferencesMenuItemsMulti = ({
	searchValue,
	handleSelectItem,
	checkedItemsArray,
}) => {
	const { t } = useTranslation(["common"]);

	const labels = useMemo(
		() => ({
			sex: (
				<Text>
					<SexIcon customMargin="0 0.25rem 0 0" customHeight="12px" />
					{t("filtersAndSelectors:categoryPreferences.0")}
				</Text>
			),
			sport: (
				<Text>
					<SportIcon
						customMargin="0 0.25rem 0 0"
						customHeight="12px"
					/>
					{t("filtersAndSelectors:categoryPreferences.2")}
				</Text>
			),
			hobby: (
				<Text>
					<HobbyIcon
						customMargin="0 0.25rem 0 0"
						customHeight="12px"
					/>
					{t("filtersAndSelectors:categoryPreferences.3")}
				</Text>
			),
			lifestyle: (
				<Text>
					<LifeStyleIcon
						customMargin="0 0.25rem 0 0"
						customHeight="12px"
					/>
					{t("filtersAndSelectors:categoryPreferences.5")}
				</Text>
			),
			culture: (
				<Text>
					<CultureIcon
						customMargin="0 0.25rem 0 0"
						customHeight="12px"
					/>
					{t("filtersAndSelectors:categoryPreferences.4")}
				</Text>
			),
			food: (
				<Text>
					<FoodIcon
						customMargin="0 0.25rem 0 0"
						customHeight="12px"
					/>
					{t("filtersAndSelectors:categoryPreferences.1")}
				</Text>
			),
		}),
		[t]
	);

	const memoizedHandleSelectItem = useCallback(handleSelectItem, [
		handleSelectItem,
	]);

	return (
		<MenuList $customPadding="0.75rem 0 0 0">
			<PreferencesSelectorChildMulti
				key={"Seksualność"}
				label={labels.sex}
				emptyText={t("common:none.3")}
				rawItems={preferencesNew[0].items}
				searchValue={searchValue}
				withMobileVersion
				withAdditionalInfo
				handleSelectItem={memoizedHandleSelectItem}
				checkedItemsArray={checkedItemsArray}
			/>
			<PreferencesSelectorChildMulti
				key={"Sport"}
				label={labels.sport}
				emptyText={t("common:none.3")}
				rawItems={preferencesNew[1].items}
				searchValue={searchValue}
				withMobileVersion
				withAdditionalInfo
				handleSelectItem={memoizedHandleSelectItem}
				checkedItemsArray={checkedItemsArray}
			/>
			<PreferencesSelectorChildMulti
				key={"Hobby"}
				label={labels.hobby}
				emptyText={t("common:none.3")}
				rawItems={preferencesNew[2].items}
				searchValue={searchValue}
				withMobileVersion
				withAdditionalInfo
				handleSelectItem={memoizedHandleSelectItem}
				checkedItemsArray={checkedItemsArray}
			/>
			<PreferencesSelectorChildMulti
				key={"Styl życia"}
				label={labels.lifestyle}
				emptyText={t("common:none.3")}
				rawItems={preferencesNew[3].items}
				searchValue={searchValue}
				withMobileVersion
				withAdditionalInfo
				handleSelectItem={memoizedHandleSelectItem}
				checkedItemsArray={checkedItemsArray}
			/>
			<PreferencesSelectorChildMulti
				key={"Kultura"}
				label={labels.culture}
				emptyText={t("common:none.3")}
				rawItems={preferencesNew[4].items}
				searchValue={searchValue}
				withMobileVersion
				withAdditionalInfo
				handleSelectItem={memoizedHandleSelectItem}
				checkedItemsArray={checkedItemsArray}
			/>
			<PreferencesSelectorChildMulti
				key={"Kuchnia"}
				label={labels.food}
				emptyText={t("common:none.3")}
				rawItems={preferencesNew[5].items}
				searchValue={searchValue}
				withMobileVersion
				withAdditionalInfo
				handleSelectItem={memoizedHandleSelectItem}
				checkedItemsArray={checkedItemsArray}
			/>
		</MenuList>
	);
};

export default PreferencesMenuItemsMulti;
